module.exports = __webpack_public_path__ + "img/new_realpleyer01.65fc389d.png";